export const BANNER_HEIGHT = 296;
export const BANNER_WIDTH = 862;
export const CONTENT_IMAGE_SIZE = 120;
